module.exports = __webpack_public_path__ + "media/images/cutting-the-flag-80dd8d8bc03559d10c15de779a480514.png";